import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from '../reducers';
import sectionIdReducer from '../reducers/sectionIdSlice';
import formReducer from '../reducers/formSlice';
import progressReducer from '../reducers/progressCheck';
import reviewFormReducer from '../reducers/reviewFormSlice';
import dataTableUpdatedReducer from '../reducers/dataTableUpdatedSlice';
import formSubmittedReducer from '../reducers/formSubmittedSlice';
import districtIdReducer from '../reducers/admin/districtIdSlice';
import sidebarReducer from '../reducers/app-global-slice';
import factSheetStatusReducer from '../reducers/factSheetStatusSlice';

const store = configureStore({
  reducer: {
    sectionId: sectionIdReducer,
    form: formReducer,
    progress: progressReducer,
    reviewForm: reviewFormReducer,
    dataTableUpdated: dataTableUpdatedReducer,
    formSubmitted: formSubmittedReducer,
    districtData: districtIdReducer,
    sidebarCollapse: sidebarReducer,
    factSheetStatus: factSheetStatusReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
// Correct RootState type (using store.getState)
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
